module.exports = __webpack_public_path__ + "59aa3a041705c3ad5c1cd6c0ea3f8ea3.svg";